export enum POPOVER_SIZE {
  CONTENT = 'content',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
export enum POPOVER_APPEARANCE {
  FOUNDATION = 'foundation',
}
